export default [
    {
        path: "/jd_index/:sports_id/:item_id?",
        name: "jd_index",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/JD/Index/index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"首页"
        }
    },
    {
        path: "/jd_item/:item_id",
        name: "jd_item",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/JD/Item/index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"列表"
        }
    },
    {
        path: "/jd_rank/:activity_id",
        name: "jd_rank",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/JD/Rank/index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"排行"
        }
    },
    {
        path: "/jd_index2/:sports_id/:item_id?",
        name: "jd_index2",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/JD/Index2/index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"首页"
        }
    },
    {
        path: "/newsdetail/:news_id",
        name: "newsdetail",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/JD/newsdetail/detail.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"详情"
        }
    },
    {
        path: "/jd_index3/:sports_id/:item_id?",
        name: "jd_index3",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/JD/Index3/index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"首页"
        }
    },
    {
        path: "/jd_index4/:sports_id/:item_id?",
        name: "jd_index4",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/JD/Index4/index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"首页",
            keepAlive: true
        }
    },
    {
        path: "/jd_comment/:sports_id",
        name: "jd_comment",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/JD/Index4/comment.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"留言板"
        }
    },
]